function cleanIds(ids) {
    if (!(ids === null || ids === void 0 ? void 0 : ids.length)) {
        return [];
    }
    var uniqueIdsSet = new Set();
    return ids
        .map(function (id) {
        var cleanedId = id.replace(/--\d+$/, '');
        if (!uniqueIdsSet.has(cleanedId)) {
            uniqueIdsSet.add(cleanedId);
            return cleanedId;
        }
        return null;
    })
        .filter(Boolean);
}
export default cleanIds;
//# sourceMappingURL=cleanIds.js.map